import styles from './index.module.less'
import { Button, Col, ConfigProvider, Row, Modal, Spin, Divider, Pagination } from 'antd'
import Section from './Section.tsx'

import ApplicationSection from '@/pages/workshop/ApplicationSection'
import ApplicationFavor from '@/pages/workshop/ApplicationSection/ApplicationFavor.tsx'
import { useNavigate } from 'react-router-dom'

import { useShallow } from 'zustand/react/shallow'
import Cockpit from '@/pages/workshop/Cockpit'

import ExtraButton from '@/pages/workshop/ExtraButton.tsx'
import FavorMenu, { FavorMenuDrawer } from '@/pages/workshop/FavorMenu'
import WorkOrderList from '@/pages/workshop/WorkOrderList'
import { useSetState } from 'ahooks'
import { useEffect, useState } from 'react'
import useWorkshopStore from '@/store/workshop.ts'
import { PlusOutlined } from '@ant-design/icons'
import { vendorRuleUnReadPage, vendorRuleViewTimes } from '@/services'
import { cloneDeep, get } from 'lodash-es'
import {authDict, getUser} from 'shj-utils'
import dayjs from 'dayjs'

const Workshop = (props: any) => {
  const navigate = useNavigate()
  const userInfo = getUser()
  const isVendor = userInfo?.currentDepartmentPosition?.deptCode === 'VENDORDEPT'
  const [state, setState] = useSetState({
    favorMenuOpen: false,
    cockpitEditOpen: false,
  })
  const [paging, setPaging] = useState<any>({ current: 1, pageSize: 10, total: 0 }) //分页
  const [tableData, setTableData] = useState<any[]>([])
  const [isModalOpen, setIsModalOpen] = useState<any>(false)
  const [loading, setLoading] = useState<any>(false)
  const [timeNum, setTimeNum] = useState<any>(10)
  const [isLoading, setIsLoading] = useSetState<any>(false)
  let timeFn
  useEffect(() => {
    // 制度弹窗暂时屏蔽
    // initFn()


    return () => {}
  }, [])
  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const timeDown = () => {
    setTimeNum(prevCount => prevCount - 1)
    if (timeNum <= 0) {
      window.clearInterval(timeFn)
    }
  }
  const imAgree = () => {
    let list: any = []
    for (let i = 0; i < tableData.length; i++) {
      list.push(tableData[i].id)
    }
    setIsLoading(true)
    vendorRuleViewTimes({ ids: list })
      .then(() => {
        handleCancel()
        setIsLoading(false)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }
  // 初始化
  const initFn = (current_?: any, pageSize_?: any) => {
    const current = current_ || paging?.current
    const pageSize = pageSize_ || paging?.pageSize
    setLoading(true)
    vendorRuleUnReadPage(current, pageSize)
      .then((resp: any) => {
        try {
          const records = get(resp, 'list', [])
          const total = get(resp, 'count', 0)
          const pageSize = get(resp, 'pageSize', 0)
          records.map((item: any) => {
            item.publishDate = dayjs(item.publishDate).format('YYYY-MM-DD HH:mm:ss')
          })
          setLoading(false)
          setTableData(records)
          setPaging({ current, pageSize, total })
          if (records.length > 0 && isVendor) {
            setIsModalOpen(true)
            timeFn = setInterval(timeDown, 1000)
          }
        } catch (error) {}
      })
      .finally(() => {
        setLoading(false)
      })
  }
  // 分页
  const onChangePagination = (current: number | undefined, pageSize: number | undefined) => {
    initFn(current, pageSize)
    setPaging({
      ...paging,
      current,
      pageSize,
    })
  }

  // const { setChatState, chatSelect } = useChatStore(
  //   useShallow((state: any) => ({
  //     setChatState: state.setChatState,
  //     chatSelect: state.chatSelect,
  //   }))
  // )

  const { getMenuCollect } = useWorkshopStore(
    useShallow((state: any) => ({
      getMenuCollect: state.getMenuCollect,
    }))
  )

  useEffect(() => {
    getMenuCollect()
  }, [])

  const handleFavorMenu = () => {
    setState({ favorMenuOpen: true })
  }

  const handleRouteWorkOrder = () => {
    navigate('/flow')
  }

  const handleEditCockpit = () => {
    setState({ cockpitEditOpen: true })
  }

  return (
    <div className={styles.wrap}>
      {/* <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null} width={900}>
        <Spin spinning={loading}>
          {tableData &&
            tableData.map((item, index) => {
              return item?.tabStatus ? (
                <div key={index}>
                  <h3>{item.ruleName}</h3>
                  <p>{item.publishDate}</p>
                  <div dangerouslySetInnerHTML={{ __html: item.ruleContent }}></div>
                  {tableData.length - 1 != index ? <Divider /> : ''}
                </div>
              ) : (
                ''
              )
            })}
          <div style={{ width: '100%' }}>
            <div style={{ float: 'right', padding: '20px 0' }}>
              <Pagination
                key="key"
                size="small"
                showSizeChanger
                showQuickJumper
                showTotal={() => `共计${paging.total}条数据`}
                onChange={onChangePagination}
                current={paging.current}
                pageSize={paging.pageSize}
                total={paging.total}
              />
            </div>
            <div style={{ clear: 'both' }} />
          </div>
          <div style={{ textAlign: 'center' }}>
            <Button type="primary" disabled={timeNum > 0} onClick={imAgree} loading={isLoading}>
              我已经清楚{timeNum > 0 ? '(' + timeNum + 's)' : ''}
            </Button>
          </div>
        </Spin>
      </Modal> */}
      <Row align="stretch" gutter={15} className={styles.sectionRow}>
        <Col span={16}>
          {/*<Section*/}
          {/*  title="驾驶舱"*/}
          {/*  extra={*/}
          {/*    <ExtraButton onClick={handleEditCockpit} icon={<PlusOutlined />}>*/}
          {/*      添加*/}
          {/*    </ExtraButton>*/}
          {/*  }*/}
          {/*>*/}
          {/*  <Cockpit />*/}
          {/*  <Cockpit.EditModal*/}
          {/*    open={state.cockpitEditOpen}*/}
          {/*    onClose={() => setState({ cockpitEditOpen: false })}*/}
          {/*  />*/}
          {/*</Section>*/}
          <Section
            title="我的工单"
            extra={<ExtraButton onClick={handleRouteWorkOrder}>查看全部</ExtraButton>}
            style={{ marginBottom: 0, height: 'calc(100% - 15px)' }}
          >
            <WorkOrderList />
          </Section>
        </Col>
        <Col span={8}>
          <Section
            title="快捷功能"
            extra={<ExtraButton onClick={handleFavorMenu}>自定义</ExtraButton>}
          >
            <FavorMenu />
          </Section>

          <Section title="常用应用">
            <ApplicationFavor />
          </Section>
          <Section title="全部应用">
            <ApplicationSection />
          </Section>
        </Col>
      </Row>
      <FavorMenuDrawer
        open={state.favorMenuOpen}
        onClose={() => setState({ favorMenuOpen: false })}
      />
    </div>
  )
}

export default Workshop
